export default __webpack_public_path__ + "static/media/tramy_logo.dee8f808.svg";